const en_ui = {
  'title'       : 'Wyrmprints Search',
  'rarity'      : 'Rarity',
  'ability'     : 'Ability',
  'condition'   : 'Condition',
  'exclusive'   : 'Exclusive',
  'availability': 'Availability',
  'name'        : 'Name',
  'search'      : 'Search',
  'clear'       : 'Clear',
  'seasonal'    : 'Seasonal',
  'event'       : 'Event',
  'collab'      : 'Collab',
  'promo'       : 'Promo'
}

export default en_ui